import React, { Component } from 'react'
import _ from 'lodash'

import { Page } from './styled'
import {
  Row,
  Form,
  Col,
  AutoComplete,
  Input,
  Button,
  message as Message
} from 'antd'

import { general } from '../../../../../../../constants'
import {
  getUserList,
  sendEmailToUsers
} from '../../../../../../../services/api/organizations'
import { ImageSelect } from '../../../../../../../components/Form'

const { ROW, Title, Select } = Page
const Option = Select.Option

class Sendmail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedImage: '',
      filteredOrgs: props.organizations,
      groups: [],
      filteredEmails: [],
      sendingEmail: false,
      emailsLoading: false,
      selectedOrgName: ''
    }
  }

  componentDidMount() {
    const { orgId } = this.props
    if (orgId) {
      this.handleOrganizationChange(orgId)
    }
  }

  onCoverChange = cover => {
    this.setState({ selectedImage: cover })
  }

  onSearch = text => {
    const { organizations } = this.props
    this.setState({
      filteredOrgs: organizations.filter(obj =>
        obj.text.toLowerCase().includes(text.toLowerCase())
      )
    })
  }

  handleUserTypeChange = val => {
    this.setState({ userType: val }, () => this.handleEmails())
  }

  handleEmails = () => {
    const {
      userType,
      signupUsers,
      nonSignupUsers,
      activeUsers,
      totalUsers
    } = this.state
    if (userType === 'signupUsers') {
      this.setState({ filteredEmails: signupUsers })
    } else if (userType === 'nonSignupUsers') {
      this.setState({ filteredEmails: nonSignupUsers })
    } else if (userType === 'activeUsers') {
      this.setState({ filteredEmails: activeUsers })
    } else if (userType === 'all') {
      this.setState({ filteredEmails: totalUsers })
    }
  }

  handleGroupSelect = id => {
    this.setState({ selectedGroupId: id })
  }

  handleOrganizationChange = (ID, param) => {
    const { orgName } = this.props
    const name = param ? param.props.children : orgName
    const id = Number(ID)
    const { response } = this.props
    const groups = response
      .filter(item => item.id === id)
      .map(item => item.groups)[0]
    this.setState(
      {
        selectedOrg: id,
        selectedOrgName: name,
        groups,
        emailsLoading: true,
        emails: [],
        selectedGroupId: null
      },
      () => this.getOrganizationUsers()
    )
  }

  getOrganizationUsers = () => {
    const { selectedOrg } = this.state
    getUserList(selectedOrg).then(res => {
      const data = res.data.rows[0]
      const totalUsers = [
        ...(data && data.sign_up_users),
        ...(data && data.non_signup_users)
      ]
      this.setState(
        {
          emailsLoading: false,
          signupUsers: data.sign_up_users,
          nonSignupUsers: data.non_signup_users,
          activeUsers: data.active_users,
          filteredEmails: totalUsers.map(item => ({
            id: item.id,
            email: item.email
          })),
          totalUsers
        },
        () => {
          if (this.state.userType) {
            this.handleEmails()
          }
        }
      )
    })
  }

  handleClosePopup = type => {
    if (type === general.SAVE) {
      this.setState({
        image: null,
        isImageLoading: true
      })
    } else {
      this.setState({
        image: null,
        file: null,
        isImageLoading: false
      })
    }
  }

  send = () => {
    const {
      subject,
      message,
      selectedImage,
      selectedOrg,
      emails,
      selectedGroupId
    } = this.state

    var emailsToSendMsg
    if (emails === undefined || emails.length === 0) {
      emailsToSendMsg = this.state.filteredEmails.map(item => ({
        email: item.email
      }))
    } else {
      emailsToSendMsg = [...emails]
    }

    if (emailsToSendMsg.length === 0) {
      return Message.error(`No users of the selected type to send email.`)
    }

    const body = {
      subject,
      message,
      path: (selectedImage && selectedImage.path) || null,
      organization_id: selectedOrg,
      group_id: selectedGroupId || null,
      users: emailsToSendMsg,
      public: true
    }
    this.setState({ sendingEmail: true }, () => {
      sendEmailToUsers(body)
        .then(() => {
          this.setState({ sendingEmail: false })
          const { onSend } = this.props
          onSend()
          Message.success('Email successfully sent !')
        })
        .catch(() => {
          Message.error('Error occured. Try again !')
          this.setState({ sendingEmail: false })
        })
    })
  }

  handleEmailSelection = arr => {
    this.setState({ emails: arr.map(item => ({ email: item })) })
  }
  render() {
    const {
      selectedImage,
      filteredOrgs,
      groups,
      selectedOrg,
      selectedOrgName,
      selectedGroupId,
      emails,
      filteredEmails,
      sendingEmail,
      emailsLoading
    } = this.state
    const { t, form } = this.props
    return (
      <Page>
        <Title>{t('v3:send_email')}</Title>
        <Col>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <AutoComplete
                value={selectedOrgName}
                dataSource={filteredOrgs}
                placeholder="Organization"
                style={{ width: '100%' }}
                onSearch={this.onSearch}
                onChange={val => this.setState({ selectedOrgName: val })}
                onSelect={() => {
                  this.handleOrganizationChange()
                  this.emailSelect.setValue([], [])
                }}
              />
            </Col>
            <Col span={12}>
              <Select
                placeholder="Group"
                disabled={!selectedOrg}
                onChange={this.handleGroupSelect}
                value={selectedGroupId}
                allowClear={selectedGroupId ? true : false}
              >
                {groups &&
                  groups.map(group => (
                    <Option key={group.id} value={group.id}>
                      {group.title}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                defaultValue="all"
                onChange={this.handleUserTypeChange}
                allowClear
              >
                <Option value="all">{t('media:all')}</Option>
                <Option value="activeUsers">{t('v3:active_users')}</Option>
                <Option value="signupUsers">{t('v3:sign_up_user')}</Option>
                <Option value="nonSignupUsers">
                  {t('v3:non_sign_up_user')}
                </Option>
              </Select>
            </Col>
            <Col span={12}>
              <Select
                showSearch
                mode="multiple"
                placeholder="Email"
                disabled={!filteredEmails || !selectedOrg}
                ref={select => (this.emailSelect = select)}
                onChange={val => {
                  this.handleEmailSelection(val)
                  this.emailSelect.blur()
                }}
                loading={emailsLoading}
              >
                {filteredEmails &&
                  filteredEmails.map((item, index) => (
                    <Option key={index} value={item.email}>
                      {item.email}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <ROW>
            <Input
              placeholder="Subject (required)"
              onChange={e => this.setState({ subject: e.target.value })}
            />
          </ROW>
          <ROW>
            <Input.TextArea
              rows="4"
              autoSize={false}
              placeholder="Message (required)"
              onChange={e => this.setState({ message: e.target.value })}
            />
          </ROW>
          <Form style={{ marginTop: '1.5rem' }}>
            <ImageSelect
              form={form}
              label={''}
              required={false}
              coverInput={selectedImage}
              onCoverChange={this.onCoverChange}
            />
          </Form>
        </Col>
        <ROW>
          <Button
            type="primary"
            shape="round"
            onClick={this.send}
            style={{ margin: '1rem auto' }}
            loading={sendingEmail}
            disabled={
              !this.state.message ||
              !this.state.subject ||
              !selectedOrg ||
              !selectedImage
            }
          >
            {t('v3:send')}
          </Button>
        </ROW>
      </Page>
    )
  }
}
export default Form.create()(Sendmail)
